import * as Yup from 'yup'

export const EmailLoginSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: Yup.string()
    .required("Password is required")
    // .min(8, "Must be at least 8 characters")
    // .matches(/[A-Z]/, "Must contain an uppercase letter")
    // .matches(/[a-z]/, "Must contain a lowercase letter")
    // .matches(/[0-9]/, "Must contain a number")
    // .matches(/[@$!%*?&]/, "Must contain a special character"),                               
})
